import React from 'react';
import { useRole } from '../contexts/RoleContext';
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Button
} from './ui';
import { Users, Package2, Tag, ChevronDown } from 'lucide-react';

const RoleSelector = () => {
  const { currentRole, setCurrentRole, COORDINATOR_ROLES, ROLE_LABELS } = useRole();

  const roleIcons = {
    [COORDINATOR_ROLES.SHIPMENT]: Users,
    [COORDINATOR_ROLES.BOX_CONTENTS]: Package2,
    [COORDINATOR_ROLES.PRODUCT_LABEL]: Tag,
  };

  const CurrentIcon = roleIcons[currentRole];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="border-slate-300 text-slate-700 hover:bg-slate-50">
          <CurrentIcon className="w-4 h-4 mr-2" />
          <span className="hidden sm:inline">{ROLE_LABELS[currentRole]}</span>
          <span className="sm:hidden">Role</span>
          <ChevronDown className="w-4 h-4 ml-2" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {Object.entries(COORDINATOR_ROLES).map(([key, roleValue]) => {
          const Icon = roleIcons[roleValue];
          const isSelected = currentRole === roleValue;
          
          return (
            <DropdownMenuItem
              key={roleValue}
              onClick={() => setCurrentRole(roleValue)}
              className={`cursor-pointer ${isSelected ? 'bg-blue-50' : ''}`}
            >
              <Icon className="w-4 h-4 mr-2" />
              <span className="flex-1">{ROLE_LABELS[roleValue]}</span>
              {isSelected && (
                <div className="w-2 h-2 bg-blue-600 rounded-full ml-2" />
              )}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default RoleSelector;